import { createTheme } from "@mui/material/styles";
import {
  darkDefaultTheme,
  lightDefaultTheme,
} from "./templates/default/defaultTheme.jsx";
const themeSwitcher = () => {
  switch (process.env.TEMPLATE_NAME) {
    case "DEFAULT": {
      return { dark: darkDefaultTheme, light: lightDefaultTheme };
    }
    default: {
      return { dark: darkDefaultTheme, light: lightDefaultTheme };
    }
  }
};

export const lightTheme = createTheme({
  ...themeSwitcher().light,
});

export const darkTheme = createTheme({
  ...themeSwitcher().dark,
});